function pad(num, size) {
	num = num.toString();
	while (num.length < size) num = '0' + num;
	return num;
}
jQuery(document).ready(function () {
	jQuery('.block-news-ticker .slider').on('init', function (event, slick) {
		jQuery(this).append(
			'<div class="slider-count"><span id="sliderticker_current">01</span><span id="sliderticker_total">' +
				pad(slick.slideCount, 2) +
				'</span></div>'
		);
	});

	jQuery('.block-news-ticker .slider').slick({});
	jQuery('.block-news-ticker .slider').on(
		'afterChange',
		function (event, slick, currentSlide) {
			jQuery('.slider-count #sliderticker_current').html(
				pad(currentSlide + 1, 2)
			);
		}
	);
});
